export const createResizeComponentHandler =
  (resizeComponent) =>
  (...args) => {
    resizeComponent(...args);
  };
